import classNames from 'classnames';
import { Switch } from '@headlessui/react';
import { ReactNode, useEffect } from 'react';

export interface ToggleProps {
  id?: string;
  label?: ReactNode;
  enabled: boolean | undefined | null;
  setEnabled: (isEnabled: boolean) => void;
  defaultToTrue?: boolean;
}

export function Toggle({
  label,
  enabled,
  setEnabled,
  id,
  defaultToTrue,
}: ToggleProps) {
  useEffect(() => {
    if (defaultToTrue && enabled !== false) {
      setEnabled(true);
    }
  }, [defaultToTrue, enabled]);

  return (
    <Switch.Group as="div" className="flex items-center" id={id}>
      <Switch
        checked={!!enabled}
        onChange={setEnabled}
        className={classNames(
          enabled ? 'bg-dark-primaryBackground' : 'bg-gray-200',
          'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-light-primary focus:ring-offset-2'
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? 'translate-x-5' : 'translate-x-0',
            'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out'
          )}
        />
      </Switch>
      {!!label && (
        <Switch.Label as="span" className="ml-3 text-sm">
          {label}
        </Switch.Label>
      )}
    </Switch.Group>
  );
}

export default Toggle;
